var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { supabase } from '@/lib/supabase';
// ─── Helpers ─────────────────────────────────────────────────────────────
var getUserId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.auth.getUser()];
            case 1:
                user = (_a.sent()).data.user;
                if (!user)
                    throw new Error('Not authenticated');
                return [2 /*return*/, user.id];
        }
    });
}); };
// ─── Clients ─────────────────────────────────────────────────────────────
export var fetchClients = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, clients, error, clientIds, _b, projectsRes, invoicesRes, filesRes, projectsByClient, invoicesByClient, filesByClient;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _c.sent();
                return [4 /*yield*/, supabase
                        .from('clients')
                        .select('*')
                        .eq('user_id', userId)
                        .order('created_at', { ascending: false })];
            case 2:
                _a = _c.sent(), clients = _a.data, error = _a.error;
                if (error)
                    throw error;
                if (!clients || clients.length === 0)
                    return [2 /*return*/, []];
                clientIds = clients.map(function (c) { return c.id; });
                return [4 /*yield*/, Promise.all([
                        supabase.from('projects').select('*').in('client_id', clientIds),
                        supabase.from('invoices').select('*').in('client_id', clientIds),
                        supabase.from('files').select('*').in('client_id', clientIds),
                    ])];
            case 3:
                _b = _c.sent(), projectsRes = _b[0], invoicesRes = _b[1], filesRes = _b[2];
                projectsByClient = groupBy(projectsRes.data || [], 'client_id');
                invoicesByClient = groupBy(invoicesRes.data || [], 'client_id');
                filesByClient = groupBy(filesRes.data || [], 'client_id');
                return [2 /*return*/, clients.map(function (c) { return ({
                        id: c.id,
                        name: c.name,
                        company: c.company || '',
                        email: c.email || '',
                        avatar: c.avatar || c.name.slice(0, 2).toUpperCase(),
                        color: c.color || '#6366f1',
                        showCardInPortal: c.show_card_in_portal || false,
                        projects: (projectsByClient[c.id] || []).map(mapProject),
                        invoices: (invoicesByClient[c.id] || []).map(mapInvoice),
                        files: (filesByClient[c.id] || []).map(mapFile),
                    }); })];
        }
    });
}); };
export var createClient = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, client, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('clients')
                        .insert({
                        user_id: userId,
                        name: data.name,
                        company: data.company,
                        email: data.email,
                        avatar: data.avatar,
                        color: data.color,
                    })
                        .select()
                        .single()];
            case 2:
                _a = _b.sent(), client = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, {
                        id: client.id,
                        name: client.name,
                        company: client.company || '',
                        email: client.email || '',
                        avatar: client.avatar || '',
                        color: client.color || '#6366f1',
                        projects: [],
                        invoices: [],
                        files: [],
                    }];
        }
    });
}); };
export var deleteClient = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('clients').delete().eq('id', clientId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var updateClient = function (clientId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('clients').update(data).eq('id', clientId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
// ─── Projects ────────────────────────────────────────────────────────────
export var createProject = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, project, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('projects')
                        .insert({
                        user_id: userId,
                        client_id: data.clientId,
                        name: data.name,
                        status: data.status || 'brief',
                        progress: data.progress || 0,
                        deadline: data.deadline || null,
                        description: data.description || '',
                        priority: data.priority || 'normal',
                    })
                        .select()
                        .single()];
            case 2:
                _a = _b.sent(), project = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, mapProject(project)];
        }
    });
}); };
export var updateProject = function (projectId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('projects').update(data).eq('id', projectId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var deleteProject = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('projects').delete().eq('id', projectId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var fetchProjectNotes = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase
                    .from('project_notes')
                    .select('*')
                    .eq('project_id', projectId)
                    .order('created_at', { ascending: false })];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, (data || [])];
        }
    });
}); };
export var createProjectNote = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, note, error;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _c.sent();
                return [4 /*yield*/, supabase
                        .from('project_notes')
                        .insert({
                        project_id: data.projectId,
                        user_id: userId,
                        text: data.text,
                        visible_to_client: (_b = data.visibleToClient) !== null && _b !== void 0 ? _b : true,
                    })
                        .select()
                        .single()];
            case 2:
                _a = _c.sent(), note = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, note];
        }
    });
}); };
export var deleteProjectNote = function (noteId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('project_notes').delete().eq('id', noteId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
// Для публичного портала — заметки по client_id
export var fetchPortalNotes = function (projectIds) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (projectIds.length === 0)
                    return [2 /*return*/, []];
                return [4 /*yield*/, supabase
                        .from('project_notes')
                        .select('*')
                        .in('project_id', projectIds)
                        .eq('visible_to_client', true)
                        .order('created_at', { ascending: false })];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, (data || [])];
        }
    });
}); };
// ─── Invoices ────────────────────────────────────────────────────────────
export var createInvoice = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, invoice, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('invoices')
                        .insert({
                        user_id: userId,
                        client_id: data.clientId,
                        number: data.number,
                        amount: data.amount,
                        status: data.status || 'pending',
                        date: data.date || new Date().toISOString().split('T')[0],
                        due_date: data.dueDate || null,
                    })
                        .select()
                        .single()];
            case 2:
                _a = _b.sent(), invoice = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, mapInvoice(invoice)];
        }
    });
}); };
export var updateInvoice = function (invoiceId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('invoices').update(data).eq('id', invoiceId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var deleteInvoice = function (invoiceId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('invoices').delete().eq('id', invoiceId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
// ─── Files (Storage) ─────────────────────────────────────────────────────
var FILE_TYPE_MAP = {
    'application/pdf': 'pdf',
    'image/png': 'image',
    'image/jpeg': 'image',
    'image/gif': 'image',
    'image/webp': 'image',
    'application/zip': 'archive',
    'application/x-rar-compressed': 'archive',
    'application/x-7z-compressed': 'archive',
};
function detectFileType(file) {
    var _a;
    if (FILE_TYPE_MAP[file.type])
        return FILE_TYPE_MAP[file.type];
    var ext = ((_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    if (['fig', 'sketch', 'psd', 'ai', 'xd'].includes(ext))
        return 'design';
    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext))
        return 'image';
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext))
        return 'archive';
    if (['pdf'].includes(ext))
        return 'pdf';
    return 'doc';
}
function formatFileSize(bytes) {
    if (bytes < 1024)
        return bytes + ' B';
    if (bytes < 1024 * 1024)
        return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
export var uploadFile = function (clientId, file) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, storagePath, uploadError, _a, fileRecord, dbError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                storagePath = "".concat(userId, "/").concat(clientId, "/").concat(Date.now(), "_").concat(file.name);
                return [4 /*yield*/, supabase.storage
                        .from('client-files')
                        .upload(storagePath, file)];
            case 2:
                uploadError = (_b.sent()).error;
                if (uploadError)
                    throw uploadError;
                return [4 /*yield*/, supabase
                        .from('files')
                        .insert({
                        user_id: userId,
                        client_id: clientId,
                        name: file.name,
                        size: formatFileSize(file.size),
                        file_type: detectFileType(file),
                        storage_path: storagePath,
                    })
                        .select()
                        .single()];
            case 3:
                _a = _b.sent(), fileRecord = _a.data, dbError = _a.error;
                if (dbError)
                    throw dbError;
                return [2 /*return*/, mapFile(fileRecord)];
        }
    });
}); };
export var downloadFile = function (storagePath) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase.storage
                    .from('client-files')
                    .createSignedUrl(storagePath, 60)];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, data.signedUrl];
        }
    });
}); };
export var deleteFile = function (fileId, storagePath) { return __awaiter(void 0, void 0, void 0, function () {
    var storageError, dbError;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.storage
                    .from('client-files')
                    .remove([storagePath])];
            case 1:
                storageError = (_a.sent()).error;
                if (storageError)
                    throw storageError;
                return [4 /*yield*/, supabase.from('files').delete().eq('id', fileId)];
            case 2:
                dbError = (_a.sent()).error;
                if (dbError)
                    throw dbError;
                return [2 /*return*/];
        }
    });
}); };
export var fetchProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('profiles')
                        .select('*')
                        .eq('id', userId)
                        .single()];
            case 2:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, data];
        }
    });
}); };
export var updateProfile = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _a.sent();
                return [4 /*yield*/, supabase.from('profiles').update(data).eq('id', userId)];
            case 2:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var uploadLogo = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, ext, storagePath, oldFiles, uploadError, data, logoUrl;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                ext = ((_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'png';
                storagePath = "".concat(userId, "/logo_").concat(Date.now(), ".").concat(ext);
                return [4 /*yield*/, supabase.storage
                        .from('brand-logos')
                        .list(userId)];
            case 2:
                oldFiles = (_b.sent()).data;
                if (!(oldFiles && oldFiles.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, supabase.storage
                        .from('brand-logos')
                        .remove(oldFiles.map(function (f) { return "".concat(userId, "/").concat(f.name); }))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [4 /*yield*/, supabase.storage
                    .from('brand-logos')
                    .upload(storagePath, file, { upsert: true })];
            case 5:
                uploadError = (_b.sent()).error;
                if (uploadError)
                    throw uploadError;
                data = supabase.storage
                    .from('brand-logos')
                    .getPublicUrl(storagePath).data;
                logoUrl = data.publicUrl;
                // Сохраняем в профиль
                return [4 /*yield*/, updateProfile({ logo_url: logoUrl })];
            case 6:
                // Сохраняем в профиль
                _b.sent();
                return [2 /*return*/, logoUrl];
        }
    });
}); };
export var deleteLogo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var userId, files;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _a.sent();
                return [4 /*yield*/, supabase.storage
                        .from('brand-logos')
                        .list(userId)];
            case 2:
                files = (_a.sent()).data;
                if (!(files && files.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, supabase.storage
                        .from('brand-logos')
                        .remove(files.map(function (f) { return "".concat(userId, "/").concat(f.name); }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, updateProfile({ logo_url: null })];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// ─── Portal Tokens ───────────────────────────────────────────────────────
export var getOrCreatePortalToken = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, existing, _a, created, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('portal_tokens')
                        .select('token')
                        .eq('client_id', clientId)
                        .eq('is_active', true)
                        .single()];
            case 2:
                existing = (_b.sent()).data;
                if (existing)
                    return [2 /*return*/, existing.token];
                return [4 /*yield*/, supabase
                        .from('portal_tokens')
                        .insert({ client_id: clientId, user_id: userId })
                        .select('token')
                        .single()];
            case 3:
                _a = _b.sent(), created = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, created.token];
        }
    });
}); };
export var deactivatePortalToken = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase
                    .from('portal_tokens')
                    .update({ is_active: false })
                    .eq('client_id', clientId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var regeneratePortalToken = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, deactivatePortalToken(clientId)];
            case 1:
                _a.sent();
                return [2 /*return*/, getOrCreatePortalToken(clientId)];
        }
    });
}); };
// Публичный запрос — без авторизации, по токену
export var fetchPortalData = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, portalToken, tokenError, clientId, userId, _b, clientRes, projectsRes, invoicesRes, filesRes, profileRes, c, profile, sub, isPro, showCard;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, supabase
                    .from('portal_tokens')
                    .select('client_id, user_id')
                    .eq('token', token)
                    .eq('is_active', true)
                    .single()];
            case 1:
                _a = _c.sent(), portalToken = _a.data, tokenError = _a.error;
                if (tokenError || !portalToken)
                    return [2 /*return*/, null];
                clientId = portalToken.client_id;
                userId = portalToken.user_id;
                return [4 /*yield*/, Promise.all([
                        supabase.from('clients').select('*').eq('id', clientId).single(),
                        supabase.from('projects').select('*').eq('client_id', clientId).order('created_at'),
                        supabase.from('invoices').select('*').eq('client_id', clientId).order('created_at'),
                        supabase.from('files').select('*').eq('client_id', clientId).order('created_at'),
                        supabase.from('profiles').select('company_name, brand_color, logo_url, card_number').eq('id', userId).single(),
                    ])];
            case 2:
                _b = _c.sent(), clientRes = _b[0], projectsRes = _b[1], invoicesRes = _b[2], filesRes = _b[3], profileRes = _b[4];
                if (clientRes.error || !clientRes.data)
                    return [2 /*return*/, null];
                c = clientRes.data;
                profile = profileRes.data;
                return [4 /*yield*/, supabase
                        .from('subscriptions')
                        .select('plan')
                        .eq('user_id', userId)
                        .eq('status', 'active')
                        .single()];
            case 3:
                sub = (_c.sent()).data;
                isPro = (sub === null || sub === void 0 ? void 0 : sub.plan) === 'pro';
                showCard = c.show_card_in_portal && (profile === null || profile === void 0 ? void 0 : profile.card_number);
                return [2 /*return*/, {
                        client: {
                            name: c.name,
                            company: c.company || '',
                            color: c.color || '#6366f1',
                        },
                        branding: isPro && profile ? {
                            companyName: profile.company_name || null,
                            brandColor: profile.brand_color || null,
                            logoUrl: profile.logo_url || null,
                        } : null,
                        cardNumber: showCard ? profile.card_number : null,
                        projects: (projectsRes.data || []).map(mapProject),
                        invoices: (invoicesRes.data || []).map(mapInvoice),
                        files: (filesRes.data || []).map(mapFile),
                    }];
        }
    });
}); };
// ─── Mappers ─────────────────────────────────────────────────────────────
function mapProject(p) {
    return {
        id: p.id,
        name: p.name,
        status: p.status || 'brief',
        progress: p.progress || 0,
        deadline: p.deadline || '',
        description: p.description || '',
        priority: p.priority || 'normal',
    };
}
function mapInvoice(i) {
    return {
        id: i.id,
        number: i.number,
        amount: i.amount,
        status: i.status || 'pending',
        date: i.date || '',
        dueDate: i.due_date || '',
    };
}
function mapFile(f) {
    return {
        id: f.id,
        name: f.name,
        size: f.size || '',
        date: f.created_at || '',
        type: f.file_type || 'doc',
        storagePath: f.storage_path || '',
    };
}
// ─── Notifications ───────────────────────────────────────────────────────
var SUPABASE_URL = 'https://cemtccfulgwewdptkukt.supabase.co';
export var fetchNotificationSettings = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase
                    .from('clients')
                    .select('notify_project_created, notify_project_status, notify_invoice_created')
                    .eq('id', clientId)
                    .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error || !data) {
                    return [2 /*return*/, { notify_project_created: true, notify_project_status: true, notify_invoice_created: true }];
                }
                return [2 /*return*/, data];
        }
    });
}); };
export var updateNotificationSettings = function (clientId, settings) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('clients').update(settings).eq('id', clientId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var sendNotification = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var settings, typeMap, session, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, fetchNotificationSettings(data.clientId)];
            case 1:
                settings = _a.sent();
                typeMap = {
                    project_created: 'notify_project_created',
                    project_status: 'notify_project_status',
                    invoice_created: 'notify_invoice_created',
                };
                if (!settings[typeMap[data.type]])
                    return [2 /*return*/]; // Уведомление выключено
                return [4 /*yield*/, supabase.auth.getSession()];
            case 2:
                session = (_a.sent()).data.session;
                if (!session)
                    return [2 /*return*/];
                return [4 /*yield*/, fetch("".concat(SUPABASE_URL, "/functions/v1/send-notification"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer ".concat(session.access_token),
                        },
                        body: JSON.stringify(__assign(__assign({}, data), { origin: window.location.origin })),
                    })];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                console.error('Failed to send notification:', err_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
// ─── Project Tasks ──────────────────────────────────────────────────────
export var fetchProjectTasks = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabase
                    .from('project_tasks')
                    .select('*')
                    .eq('project_id', projectId)
                    .order('position', { ascending: true })];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, (data || []).map(function (t) { return ({
                        id: t.id,
                        text: t.text,
                        done: t.done,
                        position: t.position,
                    }); })];
        }
    });
}); };
export var createProjectTask = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, task, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('project_tasks')
                        .insert({
                        user_id: userId,
                        project_id: data.projectId,
                        text: data.text,
                        position: data.position,
                    })
                        .select()
                        .single()];
            case 2:
                _a = _b.sent(), task = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, { id: task.id, text: task.text, done: task.done, position: task.position }];
        }
    });
}); };
export var updateProjectTask = function (taskId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('project_tasks').update(data).eq('id', taskId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var deleteProjectTask = function (taskId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('project_tasks').delete().eq('id', taskId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
// ─── Time Tracking ───────────────────────────────────────────────────────
export var fetchTimeEntries = function (projectIds) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (projectIds.length === 0)
                    return [2 /*return*/, []];
                return [4 /*yield*/, supabase
                        .from('time_entries')
                        .select('*, projects!inner(name)')
                        .in('project_id', projectIds)
                        .order('date', { ascending: false })];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, (data || []).map(mapTimeEntry)];
        }
    });
}); };
export var createTimeEntry = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, _a, entry, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getUserId()];
            case 1:
                userId = _b.sent();
                return [4 /*yield*/, supabase
                        .from('time_entries')
                        .insert({
                        user_id: userId,
                        project_id: data.projectId,
                        description: data.description,
                        duration: data.duration,
                        hourly_rate: data.hourlyRate,
                        date: data.date,
                    })
                        .select('*, projects!inner(name)')
                        .single()];
            case 2:
                _a = _b.sent(), entry = _a.data, error = _a.error;
                if (error)
                    throw error;
                return [2 /*return*/, mapTimeEntry(entry)];
        }
    });
}); };
export var updateTimeEntry = function (entryId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var update, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                update = {};
                if (data.projectId !== undefined)
                    update.project_id = data.projectId;
                if (data.description !== undefined)
                    update.description = data.description;
                if (data.duration !== undefined)
                    update.duration = data.duration;
                if (data.hourlyRate !== undefined)
                    update.hourly_rate = data.hourlyRate;
                if (data.date !== undefined)
                    update.date = data.date;
                return [4 /*yield*/, supabase.from('time_entries').update(update).eq('id', entryId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
export var deleteTimeEntry = function (entryId) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabase.from('time_entries').delete().eq('id', entryId)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [2 /*return*/];
        }
    });
}); };
function mapTimeEntry(e) {
    var _a;
    return {
        id: e.id,
        projectId: e.project_id,
        projectName: ((_a = e.projects) === null || _a === void 0 ? void 0 : _a.name) || '',
        description: e.description || '',
        duration: e.duration || 0,
        hourlyRate: e.hourly_rate,
        date: e.date || '',
    };
}
function groupBy(arr, key) {
    return arr.reduce(function (acc, item) {
        var k = item[key];
        if (!acc[k])
            acc[k] = [];
        acc[k].push(item);
        return acc;
    }, {});
}
